import { Outlet } from 'react-router-dom';
import { ConfigSidebar } from '@/components/office-config/config-sidebar';

/**
 * Shell da area Configuracoes. Sidebar lateral com os itens disponiveis
 * (3 ativos hoje) e `<Outlet />` para a subrota selecionada.
 *
 * No mobile a sidebar empilha em cima do conteudo; no desktop fica a
 * esquerda em coluna fixa.
 */
export default function ConfiguracoesLayout() {
  return (
    <div className="flex flex-col gap-6 md:flex-row md:items-start md:gap-8">
      <ConfigSidebar />
      <div data-tour="config-conteudo" className="min-w-0 flex-1">
        <Outlet />
      </div>
    </div>
  );
}
